/* =========================================
   Scrollable Words — Smooth Scroll Text
   ========================================= */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.defer = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function ensureGsap() {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve();
    var core = window.gsap
      ? Promise.resolve()
      : loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.2/gsap.min.js');
    return core.then(function () {
      if (window.ScrollTrigger) return;
      return loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.2/ScrollTrigger.min.js');
    });
  }

  function initSection(section) {
    if (!section.classList.contains('color-scheme-1')) return;
    var heading = section.querySelector('.scrollable-words__heading');
    if (!heading) return;

    var targetColor =
      section.getAttribute('data-target-color') ||
      getComputedStyle(document.documentElement).getPropertyValue('--color-accent') ||
      '#000';

    gsap.registerPlugin(ScrollTrigger);

    gsap.fromTo(
      heading,
      {
        opacity: 0.2,
        y: 60,
      },
      {
        opacity: 1,
        y: -60,
        color: targetColor.trim(),
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      }
    );
  }

  function initAll() {
    document.querySelectorAll('section.scrollable-words.color-scheme-1').forEach(initSection);
  }

  function ready(fn) {
    document.readyState !== 'loading'
      ? fn()
      : document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    ensureGsap().then(initAll);
    document.addEventListener('shopify:section:load', function (e) {
      ensureGsap().then(function () {
        initSection(e.target);
      });
    });
  });
})();
